module.exports = __webpack_public_path__ + "static/Robert Skaljin.0cbf3e29.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mentors/Robert Skaljin.jpg
// module id = 1234
// module chunks = 6166952557895